export const environment = {
  production: true,
  sentryDsn: 'https://673b8cd2b4bb1b7f763b5bb8e79f07c0@o4511237446500352.ingest.de.sentry.io/4511237477236816',
  sentryEnvironment: 'prod',
};
